"use client";

import { c as _c } from "react/compiler-runtime";
import { HeicImage } from "@/components/HeicImage";
import { isHeicImageSource } from "@/utils/heic-image";
import type { ImageProps } from "next/image";
import NextImage from "next/image";
import { useCallback, useState } from "react";
export function Image(t0) {
  const $ = _c(25);
  let props;
  let srcProp;
  if ($[0] !== t0) {
    ({
      src: srcProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = srcProp;
  } else {
    props = $[1];
    srcProp = $[2];
  }
  const [failure, setFailure] = useState();
  const src = typeof srcProp === "string" ? srcProp.startsWith("src://") ? "https://iacgobig.com/wp-content/uploads/2019/07/placeholder.png" : srcProp : srcProp;
  const terminal = failure?.source === src && failure.terminal;
  let t1;
  if ($[3] !== src || $[4] !== terminal) {
    t1 = image => {
      if (!terminal && typeof src === "string" && src && image?.complete && image.currentSrc && image.naturalWidth === 0) {
        setFailure({
          source: src,
          terminal: false
        });
      }
    };
    $[3] = src;
    $[4] = terminal;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const checkImage = t1;
  let t2;
  if ($[6] !== src) {
    t2 = () => {
      if (typeof src === "string") {
        setFailure({
          source: src,
          terminal: true
        });
      }
    };
    $[6] = src;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const conversionFailed = t2;
  let t3;
  if ($[8] !== src) {
    t3 = typeof src === "string" && src.startsWith("/api/application-files/");
    $[8] = src;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const authenticatedFile = t3;
  if (!terminal && typeof src === "string" && (isHeicImageSource(src) || failure?.source === src)) {
    const t4 = props.onError || props.onErrorCapture ? conversionFailed : undefined;
    let t5;
    if ($[10] !== props || $[11] !== src || $[12] !== t4) {
      t5 = <HeicImage {...props} src={src} onConversionError={t4} />;
      $[10] = props;
      $[11] = src;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  const t4 = authenticatedFile || props.unoptimized;
  const t5 = terminal || typeof src !== "string" || !src ? props.onError : undefined;
  let t6;
  if ($[14] !== props || $[15] !== src || $[16] !== terminal) {
    t6 = event => {
      if (!terminal && typeof src === "string" && src) {
        setFailure({
          source: src,
          terminal: false
        });
      } else {
        props.onErrorCapture?.(event);
      }
    };
    $[14] = props;
    $[15] = src;
    $[16] = terminal;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== checkImage || $[19] !== props || $[20] !== src || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = <NextImage src={src} {...props} ref={checkImage} unoptimized={t4} onError={t5} onErrorCapture={t6} />;
    $[18] = checkImage;
    $[19] = props;
    $[20] = src;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}